export default __webpack_public_path__ + "static/media/LFD_1994BG.0c6712e2.png";